import { createAction, handleActions } from 'redux-actions';
import { pender } from 'redux-pender';
import produce from 'immer';
import {
	getMeetgoReservationDetailInfo,
	getMeetgoWalkInReservationSlot,
	getMeetgoVideoReservationSlot,
	postCheckLimitForward,
	getMeetgoReservationList,
	getHomeServiceExistence,
	getCarSimple,
} from 'app/api';
import set from 'lodash/set';
import { MEETGO_RESERVATION_TYPE } from 'app/constants/meetgo';

const CHANGE_VALUE = 'meetgo/CHANGE_VALUE';
export const changeValue = createAction(CHANGE_VALUE);

const GET_RESERVATION_DETAIL_INFO = 'meetgo.reservation';

const GET_WALK_IN_RESERVATION_SLOT = 'meetgo/GET_WALK_IN_RESERVATION_SLOT';
export const getWalkInReservationSlot = createAction(GET_WALK_IN_RESERVATION_SLOT, getMeetgoWalkInReservationSlot);

const GET_VIDEO_RESERVATION_SLOT = 'meetgo/GET_VIDEO_RESERVATION_SLOT';
export const getVideosReservationSlot = createAction(GET_VIDEO_RESERVATION_SLOT, getMeetgoVideoReservationSlot);

const GET_RESERVATION_LIST = 'meetgo/GET_RESERVATION_LIST';
export const getReservationList = createAction(GET_RESERVATION_LIST, getMeetgoReservationList);

const reservation = 'meetgo.reservation';

export const postCheckLimitForwardAction = createAction(reservation, postCheckLimitForward);

export const getMeetgoReservationDetailInfoAction = createAction(GET_RESERVATION_DETAIL_INFO, getMeetgoReservationDetailInfo);

const GET_HOMESERVICE_CHECK_INFO = 'meetgo.reservation.simple';
export const getHomeServiceCheckInfoAction = createAction(GET_HOMESERVICE_CHECK_INFO, getHomeServiceExistence);

const GET_CAR_CENTER_LOCATION_INFO = 'meetgo/GET_CAR_CENTER_LOCATION_INFO';
export const getCarCenterLocationInfo = createAction(GET_CAR_CENTER_LOCATION_INFO, getCarSimple);

const initialState = {
	detailInfo: {
		salesAgentStatusType: '',
		salesAgentStatusName: '',
		vehiclePhotoPath: '',
		manufacturerName: '',
		modelGroupName: '',
		modelName: '',
		gradeName: '',
		gradeDetailName: '',
		modelYearMonth: '',
		distanceDriven: '',
		vehicleAdvertisingAmount: '',
		customerName: '',
		customerMobilePhoneNumber: '',
		useDate: '',
		useStartTime: '',
		useEndTime: '',
		centerName: '',
		centerAddress: '',
		centerPhoneNumber: '',
		salesAgentReservationId: '',
		salesAgentAdjustmentStatusType: '',
		salesAgentAdjustmentStatusName: '',
		salesAgentVehicleStatusType: '',
		salesAgentVehicleStatusName: '',
		reservationRequestDatetime: '',
		vehicleId: '',
		serviceAdvertisementId: '', // dummyCarId에 해당(믿고 전용광고)
		vehicleNo: '',
		modelYear: '',
		mileage: 0,
		advertisementPrice: 0,
		finalPrice: '',
		customerUserId: '',
		managerEmployeeId: '',
		adjustmentRequestAmount: '',
		adjustmentRequestContents: '',
		dealerId: '',
		dealerName: '',
		dealerMobilePhoneNumber: '',
		statusHistoryList: [
			{
				salesAgentStatusHistoryId: 0,
				salesAgentStatusType: '',
				salesAgentStatusChangeType: null,
				salesAgentStatusChangeContents: null,
				statusChangeDatetime: '',
				statusChangeUserId: null,
			},
		],
	},
	dateSlotList: [],
	selectedDate: '',
	selectedTime: '',
	selectedEndTime: '',
	verifiedPhone: '',
	reservationList: {
		isNone: false,
		listData: [],
		totalCount: 0,
	},
	simple: {
		existence: false,
	},
	isDetailInfoExist: false,
};

export default handleActions(
	{
		[CHANGE_VALUE]: (state, action) =>
			produce(state, (draft) => {
				const { schema, name, value } = action.payload;
				let path = [name];

				if (typeof schema === 'string') {
					path = [schema, name];
				}
				if (Array.isArray(schema)) {
					path = [...schema, ...path];
				}

				set(draft, path, value);
			}),
		...pender({
			type: GET_RESERVATION_DETAIL_INFO,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					set(draft, 'detailInfo', data);
					set(draft, 'isDetailInfoExist', true);
				}),
		}),
		...pender({
			type: GET_HOMESERVICE_CHECK_INFO,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					set(draft, 'simple', data);
				}),
		}),
		...pender({
			type: GET_WALK_IN_RESERVATION_SLOT,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					set(draft, 'dateSlotList', data.dateSlotList);
					set(draft, 'reservationType', MEETGO_RESERVATION_TYPE.WALK_IN);
				}),
		}),
		...pender({
			type: GET_VIDEO_RESERVATION_SLOT,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					set(draft, 'dateSlotList', data.dateSlotList);
					set(draft, 'reservationType', MEETGO_RESERVATION_TYPE.VIDEO_CALL);
				}),
		}),
		...pender({
			type: GET_RESERVATION_LIST,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					const { salesAgentList, totalCount } = data;
					set(draft, ['reservationList', 'listData'], salesAgentList);
					set(draft, ['reservationList', 'isNone'], salesAgentList.length === 0);
					set(draft, ['reservationList', 'totalCount'], totalCount);
				}),
		}),
		...pender({
			type: GET_CAR_CENTER_LOCATION_INFO,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					set(draft, ['detailInfo', 'centerLocation'], data.location);
				}),
		}),
	},
	initialState,
);
